export default "__VITE_ASSET__GVeov1GORNcrMmND9w0OFw__"